"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Campaign = void 0;
var Campaign = /** @class */ (function () {
    function Campaign(props) {
        this.page = 0;
        this.data = __assign(__assign({}, props.data), { eventInProgress: false, visitorSignedUp: false });
        this.renderer = props.renderer;
        this.logger = props.logger;
        this.tracker = props.tracker;
    }
    Campaign.prototype.getData = function () {
        return this.data;
    };
    Campaign.prototype.getPage = function () {
        return this.page;
    };
    Campaign.prototype.setVisitorSignedUp = function (value) {
        this.data.visitorSignedUp = value;
    };
    Campaign.prototype.setEventInProgress = function (value) {
        this.data.eventInProgress = value;
        this.refresh();
    };
    Campaign.prototype.getCoupon = function () {
        return this.data.coupon;
    };
    Campaign.prototype.setCoupon = function (value) {
        this.data.coupon = value;
    };
    Campaign.prototype.getEventInProgress = function () {
        return this.data.eventInProgress;
    };
    Campaign.prototype.render = function (page) {
        if (page === void 0) { page = this.page; }
        this.page = page;
        try {
            this.renderer.render(this.data, this.page);
            this.trackImpression();
            this.logger.trace("Campaign ".concat(this.data._id, " was rendered successfully"));
        }
        catch (error) {
            this.logger.error({ error: error }, "Something went wrong while rendering campaign ".concat(this.data._id));
        }
    };
    Campaign.prototype.refresh = function (page) {
        if (page === void 0) { page = this.page; }
        this.page = page;
        try {
            this.renderer.rerender(this.data, this.page);
            this.logger.trace("Campaign ".concat(this.data._id, " was rendered successfully"));
        }
        catch (error) {
            this.logger.error({ error: error }, "Something went wrong while rendering campaign ".concat(this.data._id));
        }
    };
    Campaign.prototype.trackImpression = function () {
        this.tracker.addImpression({ campaignID: this.data._id, isSession: false });
    };
    Campaign.prototype.destroy = function () {
        this.renderer.destroy(this.data, this.page);
    };
    Campaign.prototype.toString = function () {
        return JSON.stringify(this.data);
    };
    return Campaign;
}());
exports.Campaign = Campaign;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FtcGFpZ24uanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9jb3JlL0NhbXBhaWduLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBa0JBO0lBT0ksa0JBQVksS0FBb0I7UUFGeEIsU0FBSSxHQUFHLENBQUMsQ0FBQTtRQUdaLElBQUksQ0FBQyxJQUFJLHlCQUFRLEtBQUssQ0FBQyxJQUFJLEtBQUUsZUFBZSxFQUFFLEtBQUssRUFBRSxlQUFlLEVBQUUsS0FBSyxHQUFFLENBQUE7UUFDN0UsSUFBSSxDQUFDLFFBQVEsR0FBRyxLQUFLLENBQUMsUUFBUSxDQUFBO1FBQzlCLElBQUksQ0FBQyxNQUFNLEdBQUcsS0FBSyxDQUFDLE1BQU0sQ0FBQTtRQUMxQixJQUFJLENBQUMsT0FBTyxHQUFHLEtBQUssQ0FBQyxPQUFPLENBQUE7SUFDaEMsQ0FBQztJQUVELDBCQUFPLEdBQVA7UUFDSSxPQUFPLElBQUksQ0FBQyxJQUFJLENBQUE7SUFDcEIsQ0FBQztJQUVELDBCQUFPLEdBQVA7UUFDSSxPQUFPLElBQUksQ0FBQyxJQUFJLENBQUE7SUFDcEIsQ0FBQztJQUVELHFDQUFrQixHQUFsQixVQUFtQixLQUFjO1FBQzdCLElBQUksQ0FBQyxJQUFJLENBQUMsZUFBZSxHQUFHLEtBQUssQ0FBQTtJQUNyQyxDQUFDO0lBRUQscUNBQWtCLEdBQWxCLFVBQW1CLEtBQWM7UUFDN0IsSUFBSSxDQUFDLElBQUksQ0FBQyxlQUFlLEdBQUcsS0FBSyxDQUFBO1FBQ2pDLElBQUksQ0FBQyxPQUFPLEVBQUUsQ0FBQTtJQUNsQixDQUFDO0lBRUQsNEJBQVMsR0FBVDtRQUNJLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUE7SUFDM0IsQ0FBQztJQUVELDRCQUFTLEdBQVQsVUFBVSxLQUFjO1FBQ3BCLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxHQUFHLEtBQUssQ0FBQTtJQUM1QixDQUFDO0lBRUQscUNBQWtCLEdBQWxCO1FBQ0ksT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDLGVBQWUsQ0FBQTtJQUNwQyxDQUFDO0lBRUQseUJBQU0sR0FBTixVQUFPLElBQWdCO1FBQWhCLHFCQUFBLEVBQUEsT0FBTyxJQUFJLENBQUMsSUFBSTtRQUNuQixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQTtRQUNoQixJQUFJO1lBQ0EsSUFBSSxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7WUFDMUMsSUFBSSxDQUFDLGVBQWUsRUFBRSxDQUFBO1lBQ3RCLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLG1CQUFZLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRywrQkFBNEIsQ0FBQyxDQUFBO1NBQzNFO1FBQUMsT0FBTyxLQUFLLEVBQUU7WUFDWixJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxFQUFFLEtBQUssT0FBQSxFQUFFLEVBQUUsd0RBQWlELElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFFLENBQUMsQ0FBQTtTQUNqRztJQUNMLENBQUM7SUFFRCwwQkFBTyxHQUFQLFVBQVEsSUFBZ0I7UUFBaEIscUJBQUEsRUFBQSxPQUFPLElBQUksQ0FBQyxJQUFJO1FBQ3BCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFBO1FBRWhCLElBQUk7WUFDQSxJQUFJLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQTtZQUM1QyxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxtQkFBWSxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsK0JBQTRCLENBQUMsQ0FBQTtTQUMzRTtRQUFDLE9BQU8sS0FBSyxFQUFFO1lBQ1osSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsRUFBRSxLQUFLLE9BQUEsRUFBRSxFQUFFLHdEQUFpRCxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBRSxDQUFDLENBQUE7U0FDakc7SUFDTCxDQUFDO0lBRUQsa0NBQWUsR0FBZjtRQUNJLElBQUksQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDLEVBQUUsVUFBVSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsQ0FBQyxDQUFBO0lBQy9FLENBQUM7SUFFRCwwQkFBTyxHQUFQO1FBQ0ksSUFBSSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDL0MsQ0FBQztJQUVELDJCQUFRLEdBQVI7UUFDSSxPQUFPLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQ3BDLENBQUM7SUFDTCxlQUFDO0FBQUQsQ0FBQyxBQTVFRCxJQTRFQztBQTVFWSw0QkFBUSJ9